import { Icon_Cog, Icon_Message, Icon_Person, Sidebar } from "@shapr3d/frontend-lib";
import { useParams } from "react-router-dom";

import useNavigation from "../../../../hooks/navigation";
import { useTeam } from "../../../../hooks/useTeams";
import { useTracker } from "../../../../hooks/useTracker";
import useTranslation from "../../../../hooks/useTranslation";
import { NavGroup } from "../NavGroup/NavGroup";
import { NavItem } from "../NavItem/NavItem";

export const DashboardNavGroup = () => {
  const { t, m } = useTranslation();
  const tracker = useTracker();
  const navigation = useNavigation();
  const { teamID } = useParams();

  const { teamData } = useTeam(teamID);
  const isSyncEnabled = !teamData?.addons?.syncForbidden;

  if (!teamID) return null;

  return (
    <NavGroup>
      <Sidebar.ScrollContainer>
        {isSyncEnabled && (
          <NavItem
            name="shared-with-me"
            icon={<Icon_Person />}
            track={tracker.trackGoToSharedWithMe}
          >
            {t(m.General.SharedWithMeNav)}
          </NavItem>
        )}
        {isSyncEnabled && (
          <NavItem name="versions" icon={<Icon_Message />} track={tracker.trackGoToReviewLinks}>
            {t(m.General.PublishedVersions)}
          </NavItem>
        )}
      </Sidebar.ScrollContainer>
      <Sidebar.Space marginTop={"auto"} />
      <Sidebar.Item
        onClick={() => {
          navigation.goToTeamMembers({ teamID });
        }}
      >
        <Icon_Cog /> {t(m.General.Settings)}
      </Sidebar.Item>
    </NavGroup>
  );
};
